import React from 'react';
import { cn } from '@/lib/utils';

interface FunnelLayerProps {
  variant: 'informational' | 'analytical';
  tag: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}

export function FunnelLayer({ variant, tag, title, subtitle, children, className }: FunnelLayerProps) {
  const isAnalytical = variant === 'analytical';

  return (
    <div
      className={cn(
        'rounded-xl border p-5 space-y-4',
        isAnalytical
          ? 'bg-[#0E9D8A]/5 border-[#0E9D8A]/30'
          : 'bg-muted/30 border-border',
        className,
      )}
    >
      <div className={cn('pb-3 border-b', isAnalytical ? 'border-[#0E9D8A]/20' : 'border-border/50')}>
        <span
          className={cn(
            'inline-block text-[10px] font-semibold uppercase tracking-widest px-2 py-0.5 rounded mb-1',
            isAnalytical ? 'bg-[#0E9D8A]/15 text-[#0E9D8A]' : 'bg-muted text-muted-foreground',
          )}
        >
          {tag}
        </span>
        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
        {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
